import { AdminListHandleOnCloseFunction } from './adminListHandleOnClose.type';

const adminListHandleOnClose: AdminListHandleOnCloseFunction = ({ setAdminIdSelectedToDelete }) => {
  setAdminIdSelectedToDelete(null);
};

export default adminListHandleOnClose;
